// ================================================================
//  BOTTOM-NAV: скролл-спай + активация при клике
//  Подсвечивает пункт меню зелёным когда секция в зоне видимости
// ================================================================
const initBottomNav = () => {
  const nav = document.querySelector(".bottom-nav");
  if (!nav) return;

  const links = Array.from(nav.querySelectorAll(".bottom-nav__link"));
  if (!links.length) return;

  // Строим карту: ссылка → DOM-элемент секции
  // Поддерживает алиасы (#footer → ищет сначала #footer, потом #contacts)
  const map = links.reduce((acc, link) => {
    const href = link.getAttribute("href");
    if (!href || !href.startsWith("#")) return acc;
    const id = href.slice(1);
    const el =
      document.getElementById(id) ||
      // алиасы для совместимости
      (id === "footer" ? document.getElementById("contacts") : null) ||
      (id === "contacts" ? document.getElementById("footer") : null);
    if (el) acc.push({ link, el });
    return acc;
  }, []);

  if (!map.length) return;

  // ---- Установить активный пункт ----
  const setActive = (activeLink) => {
    links.forEach((link) => {
      const isActive = link === activeLink;
      link.classList.toggle("bottom-nav__link--active", isActive);
      link.setAttribute("aria-current", isActive ? "page" : "false");
    });
  };

  // ---- Скролл-спай ----
  // Секция считается активной, когда её верхний край прошёл 45% высоты экрана.
  // Побеждает последняя по порядку секция, чей top ≤ triggerPoint.
  let ticking = false;

  const onScroll = () => {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      const triggerPoint = window.innerHeight * 0.45;
      let activeLink = null;

      map.forEach(({ link, el }) => {
        if (el.getBoundingClientRect().top <= triggerPoint) {
          activeLink = link;
        }
      });

      setActive(activeLink);
      ticking = false;
    });
  };

  window.addEventListener("scroll", onScroll, { passive: true });

  // Запустить сразу при загрузке страницы
  onScroll();

  // ---- Мгновенная подсветка при клике (до окончания скролла) ----
  links.forEach((link) => {
    link.addEventListener("click", () => {
      setActive(link);
    });
  });
};

initBottomNav();
